// @flow

import {createSelector, defaultMemoize} from 'reselect';

import {getProcessOrphanSteps} from 'sweet-graphs';

import type {
  ProcessContentFieldArrayType,
  ProcessContentFieldType,
  ProcessContentType,
  ProcessType,
} from 'app/process/types';
import type {AnyStepType} from 'app/steps/types';
import {procedureStructureIsEqual} from 'app/procedures/utils';
import type {StoreShapeType} from 'app/reducers/types';
import {denormalizeDocument} from 'app/procedures/selectors';

export const addGIDToProceduresHTMLURL = createSelector<
  ProcessContentType,
  ProcessType,
  ProcessContentType,
  ProcessContentType,
  ProcessType
>(
  (content) => content,
  (content, process) => process,
  ({content, ...other}, process) => ({
    ...other,
    content:
      process == null
        ? content
        : content.map((item: ProcessContentFieldType) => {
            if (item.type === 'processprocedure' && item.deleted !== true) {
              return {
                ...item,
                html_url: `${item.html_url}?gid=${process.hashid}`,
              };
            } else {
              return item;
            }
          }),
  })
);

export const getMemoizedProcessOrphanSteps = defaultMemoize(
  (
    content: ProcessContentFieldArrayType,
    stepsBlockedAt: string | null | boolean
  ) => getProcessOrphanSteps(content, stepsBlockedAt),
  // this equality check function is called with all inputs in turn.
  (
    prev: Array<AnyStepType> | string | null,
    current: Array<AnyStepType> | string | null
  ) =>
    Array.isArray(prev) && Array.isArray(current)
      ? procedureStructureIsEqual(prev, current)
      : prev === current
);

export const denormalizeProcessFactory =
  (state: StoreShapeType) => (process: ProcessType) =>
    denormalizeDocument(state.teamsArea.get('basicTeams'), process);
